export default {
  namespaced: true,
  state: {},
  actions: {
    resetState({ dispatch }) {
      dispatch('WebAuthnUserPortalModule/resetState', null, { root: true });
      dispatch('WebAuthnConfigModule/resetState', null, { root: true });
    },
    async saveChanges({ dispatch }) {
      /**
       * We need to always save the config after the UP settings.
       * Because config cannot be saved if it has never been enabled in UP.
       */
      await dispatch('WebAuthnUserPortalModule/saveChanges', null, { root: true });
      return dispatch('WebAuthnConfigModule/saveChanges', null, { root: true });
    },
    initialize({ dispatch }) {
      return Promise.all([
        dispatch('WebAuthnUserPortalModule/initialize', null, { root: true }),
        dispatch('WebAuthnConfigModule/initialize', null, { root: true }),
      ]);
    },
  },
  getters: {
    enabled(state, getters, rootState, rootGetters) {
      return rootGetters['WebAuthnUserPortalModule/enabled'];
    },
    hasChanges(state, getters, rootState, rootGetters) {
      return rootGetters['WebAuthnUserPortalModule/hasChanges'] || rootGetters['WebAuthnConfigModule/hasChanges'];
    },
    hasErrors(state, getters, rootState, rootGetters) {
      return rootGetters['WebAuthnUserPortalModule/hasErrors'] || rootGetters['WebAuthnConfigModule/hasErrors'];
    },
  },
};
